import React from "react";

// styles
import "./Greeting.scss";

const getGreeting = (firstName) => {
  const hours = new Date().getHours();
  let greet;
  if (hours >= 18) {
    greet = "Good Evening";
  } else if (hours >= 12) {
    greet = "Good Afternoon";
  } else {
    greet = "Good Morning";
  }
  return (
    <h2>
      {greet} {firstName}
    </h2>
  );
};

const getSecondaryGreeting = () => {
  var days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  const day = new Date().getDay();

  return <p>Let's make the most of this {days[day]}!</p>;
};

const Greeting = ({ firstName }) => {
  return (
    <>
      <div className="greeting">
        {getGreeting(firstName)}
        {getSecondaryGreeting()}
      </div>
    </>
  );
};

export default Greeting;
